module.exports = __webpack_public_path__ + "img/facebook.a274f950.svg";